import {FeatureFlag, FeatureFlagKey} from '@hproduce/feature-flags'

// Feature flags enabled by default for the burglengenfeld test plant. Mirrors the legacy
// `available_features` list that used to be served by the `/hcem/ui/v2/config` endpoint.
export const defaultFeatureFlags: FeatureFlag[] = [
  {key: FeatureFlagKey.StorageLevels, value: true},
  {key: FeatureFlagKey.ElectricityPriceForecast, value: true},
  {key: FeatureFlagKey.SalesForecast, value: true},
  {key: FeatureFlagKey.Optimizer, value: true},
  {key: FeatureFlagKey.ProductionPlanning, value: true},
  {key: FeatureFlagKey.ElectricityPurchasing, value: true},
  {key: FeatureFlagKey.OperatorView, value: true},
  {key: FeatureFlagKey.PlanningComments, value: true},
  {key: FeatureFlagKey.OperatorViewColorCodedElectricityPrices, value: true},
  {key: FeatureFlagKey.ShutdownAvailability, value: true},
  {key: FeatureFlagKey.CostAvoidance, value: true},
  {key: FeatureFlagKey.RawMaterialsPlanning, value: true}
]
